module.exports = __webpack_public_path__ + "img/login.8e492b33.jpg";